export const MILEAGE_PROMPT_EVENT = 'mileage:prompt';

export const dispatchMileagePrompt = (sourceType, sourceReferenceId) => {
  if (!sourceType || !sourceReferenceId || typeof window === 'undefined') return;

  window.dispatchEvent(new CustomEvent(MILEAGE_PROMPT_EVENT, {
    detail: { sourceType, sourceReferenceId },
  }));
};
